// All commercial offers + phones. Edit freely to update pricing.
import { CONTACT } from "./site";

const wa = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const waFor = (label) =>
  wa(`Ciao windonline! Sono interessato a: ${label}. Potete darmi informazioni?`);

// Fastweb Mobile (rete Vodafone) — 5G fino a 2 Gbps. Wind è personalizzata.
export const MOBILE = [
  { operator: "Fastweb", name: "Start", price: "9,95", giga: "150 GB", extra: "Minuti illimitati · +15GB extra roaming · 5G" },
  { operator: "Fastweb", name: "Pro", price: "11,95", giga: "250 GB", extra: "Minuti illimitati · +45GB extra · 5G", featured: true },
  { operator: "Fastweb", name: "Power", price: "14,95", giga: "400 GB", extra: "Minuti illimitati · +65GB extra · 5G" },
  { operator: "Fastweb", name: "Ultra", price: "19,95", giga: "Giga illimitati", extra: "Tutto illimitato · Assistenza Salute inclusa" },
  { operator: "Wind", name: "Su misura", price: null, giga: "Personalizzata", extra: "Tariffa costruita in base al tuo operatore di provenienza", custom: true },
];

export const MOBILE_NOTE = "Contributo SIM/eSIM 10€ · velocità 5G fino a 2 Gbps.";

// Fibra — Wind esatto; Fastweb Casa dalla scheda ufficiale (per clienti mobile).
export const FIBRA = [
  { operator: "Wind", tier: "Casa", price: "19,99", speed: "Fino a 2,5 Gbps", tech: "", perks: ["SIM mobile a 7,99€ illimitata (Giga e minuti)"], featured: true },
  { operator: "Fastweb e Vodafone", tier: "Casa Start", price: "23,95", oldPrice: "27,95", speed: "Fino a 2,5 Gbps", tech: "Internet Box NeXXt One", perks: ["Chiamate a consumo", "0 vincoli · 0 attivazione", "Wi-Fi Booster opzionale"] },
  { operator: "Fastweb e Vodafone", tier: "Casa Pro", price: "25,95", oldPrice: "29,95", speed: "Fino a 2,5 Gbps", tech: "Fastweb Seven · Wi-Fi 7", perks: ["Chiamate illimitate", "Polizza Assistenza Casa inclusa", "+ Giga illimitati per clienti mobile"] },
  { operator: "Fastweb e Vodafone", tier: "Casa Ultra", price: "32,95", oldPrice: "36,95", speed: "Fino a 2,5 Gbps", tech: "Fino a 2 modem Fastweb Seven", perks: ["Chiamate illimitate", "2 polizze: Casa + Salute", "+ Giga illimitati per clienti mobile"] },
];

export const ENERGY_PACKS = {
  title: "Fastweb Energia — Prezzo fisso 3 anni",
  note: "Rata mensile tutto compreso, IVA inclusa. In base al consumo annuo.",
  items: [
    { price: "30", range: "fino a 800 kWh/anno" },
    { price: "45", range: "fino a 1.500 kWh/anno" },
    { price: "65", range: "fino a 2.500 kWh/anno" },
    { price: "80", range: "fino a 3.500 kWh/anno" },
    { price: "95", range: "fino a 4.500 kWh/anno" },
  ],
};

export const ENERGY_TARIFFS = [
  {
    operator: "Fastweb", lock: "Prezzo a consumo",
    logo: "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/5l721yho_Fastweb-energia-logo.jpg",
    luce: { rate: "0,11 €/kWh", fee: "8€/mese comm." },
    gas: { rate: "0,48 €/Smc", fee: "4€/mese comm." },
  },
  {
    operator: "Iren", lock: "Bloccato 2 anni",
    logo: "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/bcn97rei_iren-offerte-imprese-e1628156300204.png",
    luce: { rate: "0,10 €/kWh", fee: "13€/mese comm." },
    gas: { rate: "0,44 €/Smc", fee: "13€/mese comm." },
  },
  {
    operator: "WindTre", lock: "Prezzo a consumo",
    logo: "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/rl7ogall_windtre-luce-gas.png",
    luce: { rate: "0,12 €/kWh", fee: "7,5€/mese comm." },
    gas: { rate: "0,50 €/Smc", fee: "7,5€/mese comm." },
  },
];

const IMG_IPHONE_17 = "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/vnr8vp8d_iPhone_17_Black_PDP_Image_Position_1__ITIT.jpg";
const IMG_IPHONE_17_PRO = "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/yvkfyst1_iPhone_17_Pro_Deep_Blue_PDP_Image_Position_1__ITIT.jpg";
const IMG_IPHONE_17_PROMAX = "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/f9ulf8oq_iPhone_17_Pro_Max_Cosmic_Orange_PDP_Image_Position_1__ITIT.jpg";
const IMG_S26 = "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/12ymygrh_galaxy_s26_black_00.jpg";
const IMG_S26_ULTRA = "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/zi05oyu8_galaxy_s26ultra_black_00_1%20%281%29.jpg";

const IMG_IPHONE_AIR = "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/qkpe6ory_iPhone_Air_Cloud_White_PDP_Image_Position_1__ITIT.jpg";

export const PHONES = [
  { brand: "Apple", model: "iPhone 17", storage: "256GB", color: "Black", monthly: "18,85", months: 48, cash: "979", img: IMG_IPHONE_17 },
  { brand: "Apple", model: "iPhone Air", storage: "256GB", color: "Cloud White", monthly: "21,25", months: 48, cash: "1239", img: IMG_IPHONE_AIR },
  { brand: "Apple", model: "iPhone 17 Pro", storage: "256GB", color: "Deep Blue", monthly: "26,00", months: 48, cash: "1339", img: IMG_IPHONE_17_PRO, featured: true },
  { brand: "Apple", model: "iPhone 17 Pro Max", storage: "256GB", color: "Cosmic Orange", monthly: "30,86", months: 48, cash: "1489", img: IMG_IPHONE_17_PROMAX },
  { brand: "Samsung", model: "Galaxy S26", storage: "256GB", color: "Black", monthly: "10,00", months: 48, cash: "1029", img: IMG_S26, promo: true },
  { brand: "Samsung", model: "Galaxy S26 Ultra", storage: "256GB", color: "Black", monthly: "18,00", months: 48, cash: "1499", img: IMG_S26_ULTRA },
  { brand: "Apple", model: "iPhone Ricondizionati", storage: "Dal 13 al 16", color: "Base · Pro · Pro Max", img: "https://customer-assets-agu9un31.emergentagent.net/job_mobile-solutions-pro-1/artifacts/j3jnas7y_iphone-13-pro-max-1631712388.jpg", refurb: true },
];
